const warehouseSlotsModel = vm => ({
  title: vm.$gettext('Warehouse Slots'),
  endpoint: 'warehouse-slots',
  allowNew: true,
  allowDelete: true,
  countrize: 'warehouse.country_iso_code',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'warehouse_id',
      label: vm.$gettext('Warehouse'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Home of the slot'),
      type: 'select',
      options: 'warehousesById',
      showField: 'reference',
      withSelect: true,
      formatter: (value, key, item) => {
        return item.warehouse && item.warehouse.reference ? item.warehouse.reference : ''
      }
    },
    {
      key: 'code',
      label: vm.$gettext('Code'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext('Code text or number to identify the slot')
    },
    {
      key: 'reference',
      label: vm.$gettext('Reference'),
      sortable: true,
      editable: true,
      description: vm.$gettext('Reference text to identify the slot')
    },
    {
      key: 'tour_id',
      label: vm.$gettext('Tour'),
      editable: false,
      formatter: (value, key, item) => {
        return value ? '<a href="/edit/tours/' + value + '" target="_blank">#' + value + '</a>' : ''
      }
    }
  ],
  includes: ['warehouse'],
  filters: ['id', 'reference', 'code', 'warehouse.reference', 'warehouse.country_iso_code', 'tour_id']
})

export default warehouseSlotsModel
